import script from "./addproduct.vue?vue&type=script&setup=true&lang=js"
export * from "./addproduct.vue?vue&type=script&setup=true&lang=js"

import "./addproduct.vue?vue&type=style&index=0&id=8766bd14&lang=css"

const __exports__ = script;

export default __exports__